import React from "react"
import {
  BoldText,
  ClassTitle,
  PriceIncluded,
  Spacer,
  Table,
  TableBody,
  TableBodyData,
  TableCell,
  TableContainer,
  TableHeader,
  TableHeading,
  TableRow,
} from "./styles"

const ClassesCategoryTable = ({ classes }) => (
  <TableContainer>
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeading firstRow>Class</TableHeading>
          <TableHeading hideOnMobile>Hours</TableHeading>
          <TableHeading hideOnMobile>Price</TableHeading>
        </TableRow>
      </TableHeader>
      {classes.map((cls) => (
        <TableBody key={`${cls.title}-${cls.price}`}>
          <TableRow>
            <TableCell firstRow>
              <ClassTitle> {cls.title}</ClassTitle>
              <br />
              {cls.shortDescription}
              <TableBodyData>
                <Spacer />
                Hours: {Math.round(cls.totalDuration / 3600)} <Spacer />
                Price:
                {` $${parseFloat(cls.price).toFixed(2)}`}
              </TableBodyData>
            </TableCell>

            <TableCell hideOnMobile>{parseInt(cls.totalDuration / 3600)}</TableCell>
            <TableCell hideOnMobile>
              <BoldText>
                <PriceIncluded>{`$${parseFloat(cls.price).toFixed(2)} `} </PriceIncluded>
                Included
              </BoldText>
            </TableCell>
          </TableRow>
        </TableBody>
      ))}
    </Table>
  </TableContainer>
)
export default ClassesCategoryTable
